var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.location.location_status,
          expression: "location.location_status",
        },
      ],
      attrs: {
        type: "hidden",
        name: "locations[" + _vm.location_index + "][location_status]",
      },
      domProps: { value: _vm.location.location_status },
      on: {
        input: function ($event) {
          if ($event.target.composing) return
          _vm.$set(_vm.location, "location_status", $event.target.value)
        },
      },
    }),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.location.location_name,
          expression: "location.location_name",
        },
      ],
      attrs: {
        type: "hidden",
        name: "locations[" + _vm.location_index + "][location_name]",
      },
      domProps: { value: _vm.location.location_name },
      on: {
        input: function ($event) {
          if ($event.target.composing) return
          _vm.$set(_vm.location, "location_name", $event.target.value)
        },
      },
    }),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.location.zip,
          expression: "location.zip",
        },
      ],
      attrs: {
        type: "hidden",
        name: "locations[" + _vm.location_index + "][zip]",
      },
      domProps: { value: _vm.location.zip },
      on: {
        input: function ($event) {
          if ($event.target.composing) return
          _vm.$set(_vm.location, "zip", $event.target.value)
        },
      },
    }),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.location.pref,
          expression: "location.pref",
        },
      ],
      attrs: {
        type: "hidden",
        name: "locations[" + _vm.location_index + "][pref]",
      },
      domProps: { value: _vm.location.pref },
      on: {
        input: function ($event) {
          if ($event.target.composing) return
          _vm.$set(_vm.location, "pref", $event.target.value)
        },
      },
    }),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.location.address,
          expression: "location.address",
        },
      ],
      attrs: {
        type: "hidden",
        name: "locations[" + _vm.location_index + "][address]",
      },
      domProps: { value: _vm.location.address },
      on: {
        input: function ($event) {
          if ($event.target.composing) return
          _vm.$set(_vm.location, "address", $event.target.value)
        },
      },
    }),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.location.tel,
          expression: "location.tel",
        },
      ],
      attrs: {
        type: "hidden",
        name: "locations[" + _vm.location_index + "][tel]",
      },
      domProps: { value: _vm.location.tel },
      on: {
        input: function ($event) {
          if ($event.target.composing) return
          _vm.$set(_vm.location, "tel", $event.target.value)
        },
      },
    }),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.location.fax,
          expression: "location.fax",
        },
      ],
      attrs: {
        type: "hidden",
        name: "locations[" + _vm.location_index + "][fax]",
      },
      domProps: { value: _vm.location.fax },
      on: {
        input: function ($event) {
          if ($event.target.composing) return
          _vm.$set(_vm.location, "fax", $event.target.value)
        },
      },
    }),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.location.business_hours,
          expression: "location.business_hours",
        },
      ],
      attrs: {
        type: "hidden",
        name: "locations[" + _vm.location_index + "][business_hours]",
      },
      domProps: { value: _vm.location.business_hours },
      on: {
        input: function ($event) {
          if ($event.target.composing) return
          _vm.$set(_vm.location, "business_hours", $event.target.value)
        },
      },
    }),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.location.access,
          expression: "location.access",
        },
      ],
      attrs: {
        type: "hidden",
        name: "locations[" + _vm.location_index + "][access]",
      },
      domProps: { value: _vm.location.access },
      on: {
        input: function ($event) {
          if ($event.target.composing) return
          _vm.$set(_vm.location, "access", $event.target.value)
        },
      },
    }),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.location.map_type,
          expression: "location.map_type",
        },
      ],
      attrs: {
        type: "hidden",
        name: "locations[" + _vm.location_index + "][map_type]",
      },
      domProps: { value: _vm.location.map_type },
      on: {
        input: function ($event) {
          if ($event.target.composing) return
          _vm.$set(_vm.location, "map_type", $event.target.value)
        },
      },
    }),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.location.google_map_url,
          expression: "location.google_map_url",
        },
      ],
      attrs: {
        type: "hidden",
        name: "locations[" + _vm.location_index + "][google_map_url]",
      },
      domProps: { value: _vm.location.google_map_url },
      on: {
        input: function ($event) {
          if ($event.target.composing) return
          _vm.$set(_vm.location, "google_map_url", $event.target.value)
        },
      },
    }),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.location.google_map_embed,
          expression: "location.google_map_embed",
        },
      ],
      attrs: {
        type: "hidden",
        name: "locations[" + _vm.location_index + "][google_map_embed]",
      },
      domProps: { value: _vm.location.google_map_embed },
      on: {
        input: function ($event) {
          if ($event.target.composing) return
          _vm.$set(_vm.location, "google_map_embed", $event.target.value)
        },
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }